/**
 * Smooth scroll only landed in Safari IOS 15
 *
 * @see https://caniuse.com/css-scroll-behavior
 */
import smoothscroll from 'smoothscroll-polyfill';
import { hydrateRoot } from 'react-dom/client';
import App from './Components/App';
import { document, window } from '../../../js/globals';
import { createSearchClient } from '../general/searchClient';

smoothscroll.polyfill();

const container = document?.getElementById('faq-page-algolia');
const { FAQ_ALGOLIA_DATA } = window as Window;

if (container && FAQ_ALGOLIA_DATA) {
  const searchClient = createSearchClient(
    FAQ_ALGOLIA_DATA.appID,
    FAQ_ALGOLIA_DATA.searchApiKey,
  );

  hydrateRoot(
    container,
    <App
      faqData={FAQ_ALGOLIA_DATA}
      algoliaServerState={FAQ_ALGOLIA_DATA.algoliaServerState}
      searchClient={searchClient}
    />,
  );
}
